export const brandKeywords = {
  menicon: {
    myopia: ['bloom', 'acuvue'],
    nonMyopiaExclude: ['bloom']
  },
  other: {
    myopia: ['acuvue']
  }
};
